import React, { useContext } from "react";

import makeStyles from '@mui/styles/makeStyles';
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";

import messages from "../services/messages";
import config from "../config";
import ShareDialog from "./ShareDialog";
import LanguageContext from "../LanguageContext";
import UserService from "../services/UserService";
import firebase from "../firebase";
import { DoneAll, PanTool, Schedule } from "@mui/icons-material";
import Button from "@mui/material/Button";
import { WhatsappShareButton } from "react-share";

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: "8px",
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
  contentContainer: {
    marginBottom: theme.spacing(-1),
    alignItems: "stretch",
  },
  remindMeIcon: {
    height: "16px",
  },
  remindMeButton: {
    backgroundColor: "#FAF4F4",
    color: "#9D2123",
    width: "100%",
    marginTop: "2%",
  },
  seatReservedButton: {
    backgroundColor: "#DDDDDD",
    color: "#666666",
    "&:disabled": {
      color: "#666666",
    },
  },
  avatar: { width: theme.spacing(3.5), height: theme.spacing(3.5) },
  authorName: {
    // marginLeft: theme.spacing(0),
  },
  scheduleIcon: {
    marginBottom: theme.spacing(-0.5),
    height: theme.spacing(2.0),
  },
  authorContainer: {
    // marginBottom: theme.spacing(0.5),
    // marginTop: theme.spacing(0.5),
    alignItems: "center",
  },
  spacing: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  headerContainer: {
    // height: theme.spacing(13),
    overflow: "hidden",
  },
  shareIconContainer: {
    // marginTop: theme.spacing(1),
  },
  shareIcon: {
    marginTop: theme.spacing(1.7),
    height: theme.spacing(2.5),
  },
  timeTitleContainer: {
    marginTop: theme.spacing(1),
  },
  timeTitle: {
    color: "#FFFFFF",
    fontSize: theme.spacing(1.5),
  },
  timeTitleText: {
    background: `#666666`,
    borderRadius: theme.spacing(0.5),
    paddingLeft: theme.spacing(0.2),
    paddingTop: theme.spacing(0.5),
    paddingRight: theme.spacing(1),
    paddingBottom: theme.spacing(0.5),
  },
}));

export default function UpcomingContentCardHorizontal(props) {
  const classes = useStyles();
  const [openShareDialog, setOpenShareDialog] = React.useState(false);
  const [remindMe, setRemindMe] = React.useState(false);
  const handleClickOpen = () => {
    setOpenShareDialog(true);
  };
  const language = useContext(LanguageContext);
  const { mobile } = UserService.getUserInfo();

  const getShareText = () => {
    let shareText = `${props.upcomingMeeting.sessionTopic} ${messages["cropPage.upcoming.shareText1"][language]} ${props.upcomingMeeting.cropName}  ${messages["cropPage.upcoming.shareText2"][language]} ${props.upcomingMeeting.startTime} ${messages["cropPage.upcoming.shareText3"][language]}`;

    return shareText;
  };
  const handleRemindMe = () => {
    firebase.analytics().logEvent("remindme_clicked", {
      mobile,
      crop_name: props.upcomingMeeting.crop.name_en,
      author_name: props.upcomingMeeting.author.name_en,
      session_topic: props.upcomingMeeting.sessionTopic,
      start_time: props.upcomingMeeting.startTime,
      state: props.upcomingMeeting.state.name_en,
      week: props.upcomingMeeting.week,
      position: props.position,
      user_type: props.userType,
      farmer_crops: JSON.stringify(props.farmerCrops),
      user_source: props.userSource,
    });
    setRemindMe(true);
  };
  const handleClose = (value) => {
    setOpenShareDialog(false);
  };

  const share = async () => {
    firebase.analytics().logEvent("upcoming_class_shared_on_whatsapp", {
      mobile,
      crop_name: props.upcomingMeeting.crop.name_en,
      author_name: props.upcomingMeeting.author.name_en,
      session_topic: props.upcomingMeeting.sessionTopic,
      week: props.upcomingMeeting.week,
      position: props.position,
      user_type: props.userType,
      farmer_crops: JSON.stringify(props.farmerCrops),
      state: props?.upcomingMeeting?.state[0].name_en,
      class_start_time: props.upcomingMeeting.startTime,
      user_source: props?.userSource,
    });
  };
  return <>
    <Card className={classes.root} variant={"outlined"}>
      <div style={{ backgroundColor: props.upcomingMeeting.crop.color }}>
        <CardContent>
          <Grid
            container
            direction="row"
            justifyContent={"flex-start"}
            alignItems={"center"}
          >
            <Grid item xs={8}>
              <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
              >
                <Grid item>
                  <Typography
                    variant={"h6"}
                    style={{
                      width: "120%",
                      fontSize: "1.15rem",
                      lineHeight: "1",
                    }}
                  >
                    {props.upcomingMeeting.cropName}
                    {props.upcomingMeeting.week &&
                      props.upcomingMeeting.week !== "" && <> &bull; </>}
                    {props.upcomingMeeting.week}
                  </Typography>
                </Grid>
              </Grid>
              <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="stretch"
                className={classes.timeTitleContainer}
              >
                <Grid item xs={12}>
                  <Typography className={classes.timeTitle}>
                    <span className={classes.timeTitleText}>
                      <Schedule className={classes.scheduleIcon} />{" "}
                      {props.upcomingMeeting.startTime}
                    </span>
                  </Typography>

                  {/*<Chip*/}
                  {/*  style={{ backgroundColor: "rgba(255, 255, 255, 0.2)" }}*/}
                  {/*  label={props.upcomingMeeting.startTime}*/}
                  {/*  size={"small"}*/}
                  {/*/>*/}
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={4}>
              <CardMedia
                component="img"
                height="60"
                image={props.upcomingMeeting.cropImage}
                alt={props.upcomingMeeting.cropName}
                title={props.upcomingMeeting.cropName}
              />
            </Grid>
          </Grid>
        </CardContent>
      </div>
      <CardContent className={classes.contentContainer}>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="stretch"
        >
          <Grid item xs={12} style={{ overflow: "hidden" }}>
            <Typography gutterBottom variant="body2">
              {props.upcomingMeeting.longDescription}
            </Typography>
          </Grid>
        </Grid>

        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="stretch"
          className={classes.authorContainer}
        >
          <Grid item xs={2}>
            <Avatar
              aria-label="author"
              src={props.upcomingMeeting.authorImage}
              className={classes.avatar}
            >
              {props.upcomingMeeting && props.upcomingMeeting.authorName && (
                <> {props.upcomingMeeting.authorName.charAt(0)}</>
              )}
            </Avatar>
          </Grid>
          <Grid item xs={8}>
            <Typography variant={"caption"} className={classes.authorName}>
              {messages["dashboard.live.byAuthor"][language]}
              {props.upcomingMeeting.authorName}
            </Typography>
          </Grid>
          <Grid item xs={2}>
            <WhatsappShareButton
              url={`https://agrostar.onelink.me/9ngX/gold${props.userState?.code?.toLowerCase()}`}
              title={`${getShareText()}`}
              onClick={share}
              className={classes.shareIconContainer}
            >
              <img
                className={classes.shareIcon}
                src="../../icons/whatsapp.svg"
                alt="whatsapp-share"
              />
            </WhatsappShareButton>
          </Grid>
        </Grid>
        <Grid container direction="row" justifyContent="center" alignItems="stretch">
          <Grid
            style={{ marginBottom: "10px" }}
            item
            xs={12}
            className={classes.spacing}
          >
            {!remindMe && (
              <Button
                variant={"contained"}
                className={classes.remindMeButton}
                onClick={handleRemindMe}
              >
                <PanTool className={classes.remindMeIcon} />{" "}
                {messages["dashboard.remindMe.buttonText"][language]}
              </Button>
            )}
            {remindMe && (
              <Button
                variant={"contained"}
                fullWidth={true}
                disabled
                className={classes.seatReservedButton}
              >
                <DoneAll className={classes.remindMeIcon} />{" "}
                {messages["dashboard.seatReserved.buttonText"][language]}
              </Button>
            )}
          </Grid>

          <Grid item xs={12} className={classes.spacing}></Grid>
        </Grid>
      </CardContent>
    </Card>
    <ShareDialog
      handleClose={handleClose}
      sessionTopic={props.upcomingMeeting.sessionTopic}
      week={props.upcomingMeeting.week}
      shareText={`${getShareText()}`}
      shortDescription={`${props.upcomingMeeting.cropName} - ${props.upcomingMeeting.shortDescription}`}
      url={`https://agrostar.onelink.me/9ngX/gold${props.userState?.code?.toLowerCase()}`}
      handleOpen={handleClickOpen}
      open={openShareDialog}
      cropName={props.upcomingMeeting.crop.name_en}
      authorName={props.upcomingMeeting.author.name_en}
      mobile={mobile}
      position={props.position}
      userType={props.userType}
      state={props?.upcomingMeeting?.state[0]?.name_en}
      startTime={props?.upcomingMeeting.startTime}
      userSource={props?.userSource}
      classType={`upcoming_class`}
    />
  </>;
}
